/**
 * 价格千分位格式化
 * @param {number|string} val 原始价格
 * @returns {string} 格式化后 1,234,567
 */
// export function formatPriceThousand(val) {
//   if (val === null || val === undefined || val === '') return '0';
//   const num = Number(val);
//   if (isNaN(num)) return '0';
//   // toLocaleString 原生千分位
//   return num.toLocaleString('zh-CN');
// }

// export function formatPriceThousand(val) {
//   if (val === null || val === undefined || val === '') return '0';
//   let num = Number(val);
//   if (isNaN(num)) return '0';
//   // 分离整数、小数
//   const parts = num.toString().split('.');
//   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   return parts.join('.');
// }

/**
 * 价格千分位格式化
 * @param {number|string|null|undefined} val 原始价格
 * @returns {string} 格式化后 1,234,567 / -1,234,567 / 12,345.99
 */
export function formatPriceThousand(val) {
	// null、undefined、空字符串直接返回 0
	if (val === null || val === undefined || val === '') {
		return '0';
	}

	const num = Number(val);

	// 无法转为有效数字返回 0
	if (isNaN(num)) {
		return '0';
	}

	// 处理 -0 特殊情况，统一输出 0
	if (Object.is(num, -0) || num === 0) {
		return '0';
	}

	// 标记正负，用绝对值处理千分位，避免负号干扰正则
	const isNegative = num < 0;
	const absNum = Math.abs(num);
	const parts = absNum.toString().split('.');

	// 整数部分添加千分位逗号
	parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

	let result = parts.join('.');
	// 还原负号
	if (isNegative) {
		result = '-' + result;
	}

	return result;
}